import mixpanel from 'mixpanel-browser';

const TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined;
const IS_PROD = import.meta.env.MODE === 'production';

export const analytics = {
  init() {
    if (!TOKEN) return;
    mixpanel.init(TOKEN, {
      debug: !IS_PROD,
      track_pageview: false, // we handle page views manually
      persistence: 'localStorage',
    });
  },

  identify(userId: string, traits?: Record<string, unknown>) {
    if (!TOKEN) return;
    mixpanel.identify(userId);
    if (traits) {
      mixpanel.people.set(traits);
    }
  },

  track(event: string, properties?: Record<string, unknown>) {
    if (!TOKEN) return;
    mixpanel.track(event, properties);
  },

  page(pathname: string) {
    if (!TOKEN) return;
    mixpanel.track('Page Viewed', { path: pathname });
  },

  reset() {
    if (!TOKEN) return;
    mixpanel.reset();
  },
};
